"use client";
import { useEffect, useState } from 'react';

import { useLanguage } from "@/app/utils/LanguageContext";
import Footer from "@/app/ui/footer";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";

import _ from 'lodash';
import { getAssetPrefix, adobeData, updateMetaTag, getSearchParams } from "@/app/utils/Common";
import NoInformation from "../Common/NoInformation";
import { getHorseFormerName } from "@/app/utils/request/requestList";
import {formattedDate, dateFormat, toDate} from "@/app/utils/DayJS"; 
import moment from "moment";
import { pageSet } from "@/app/utils/pageSet";

const HorseFormerName: React.FC = () => {
  const { state: lang } = useLanguage();
  const assetPrefix = getAssetPrefix();
  const [loading, setloading ] = useState(true);  
  const { t, langCode } = lang;
  
  const [hasData, setHasData] = useState(0); 
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    updateMetaTag(langCode, pageSet.horseformername);
    adobeData(langCode, "pageview", {
      pageId: "racing/local",
    });
    
    getData()
  }, [])

  //get QIDS Data
  const getData = () => { 
    getHorseFormerName()
      .then(async (res: any) => {  
          if(!res)
          {
            setHasData(2);
            setloading(false);
            return;
          } 
          console.log("getHorseFormerName", res)
          
          if(res?.horses.length > 0) {
            setHasData(1)
            let tempRes = res?.horses?.map((i:any) => {
              return {
                ...i,
                cntyOfOrgCode : i?.cntyOfOrg?.code,
                name_enSort : i?.name_en?.replace(" ", "9").replace("'", ""),
              }
            })
            const { frmsorttype } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));
            switch (frmsorttype?.toLowerCase())
            {
              case "horse_name":
                tempRes = _.sortBy(tempRes, ['name_enSort'])
                // page.HorseFormers = horseFormers._.orderBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;
              case "horse_former_name":
                tempRes = _.orderBy(tempRes, ['formerName', 'name_enSort'], ['asc', 'asc'])
                // page.HorseFormers = horseFormers._.orderBy(x => x.FormerName).ThenBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;
              case "sire":
                 tempRes = _.orderBy(tempRes, ['sire', 'name_enSort'], ['asc', 'asc'])
                // page.HorseFormers = horseFormers._.orderBy(x => x.Sire).ThenBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;
              case "dam":
                 tempRes = _.orderBy(tempRes, ['dam', 'name_enSort'], ['asc', 'asc'])
                // page.HorseFormers = horseFormers._.orderBy(x => x.Dam).ThenBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;
              case "horse_imported_type":
                 tempRes = _.orderBy(tempRes, ['importType', 'name_enSort'], ['asc', 'asc'])
                // page.HorseFormers = horseFormers._.orderBy(x => x.ImportCode).ThenBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;
              case "country_of_origin":
                 tempRes = _.orderBy(tempRes, ['cntyOfOrgCode', 'name_enSort'], ['asc', 'asc'])
                // page.HorseFormers = horseFormers._.orderBy(x => x.CountryCode).ThenBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;
              case "horse_age":
                 tempRes = tempRes?.sort((a:any, b:any) => {
                  if (a.age !== b.age) {
                    return a.age - b.age;
                  }
                  return a?.name_enSort.localeCompare(b?.name_enSort, 'en', {sensitivity: "base"})
                 })
                // page.HorseFormers = horseFormers._.orderBy(x => x.Age).ThenBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;
              case "foaling_date":
                 tempRes = _.orderBy(tempRes, ['foalingDate', 'name_enSort'], ['asc', 'asc'])
                // page.HorseFormers = horseFormers._.orderBy(x => x.FoalingDate).ThenBy(x => x.EnglishHorseName.Replace(" ", "9"));
                break;

              default:
                tempRes = _.sortBy(tempRes, ['name_enSort'])
                break;
            };
            setData(tempRes)
          }
      })
      .catch((e: any) => {
        console.log(e);
      }).finally(() => {
        setloading(false)
      });;
  }

  const handleDate = (date: string, format: string) => {
    if (!date) return "----";
    return formattedDate(toDate(date.split("+")[0], format), format)
  }
  return (
    <>
      <div id='mainContainer'>
        <Header />
        <HeaderNav />
        {
          loading ? <></> :
          hasData != 1 ? <NoInformation type="noinfo" /> : 
            (
              <div className="commContent f_fs13">
                <div className="commTitlePic"  style={{ paddingLeft: "10px" }}>
                  <img src={`${assetPrefix}/images/title_horses_former_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} />
                </div>
                <table width="760" border={1} className="horseFormerNameTable" cellSpacing="1" cellPadding="0">
                    <thead>
                      <tr>
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=HORSE_NAME`}>{t("englishName")}</a></td>	
                        {lang?.langCode == "en-us" ? <></> : <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=HORSE_NAME_C`}>{t("chineseName")}</a></td>	}
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=HORSE_FORMER_NAME`}>{t("formerName")}</a></td>
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=SIRE`}>{t("sire")}</a></td>
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=DAM`}>{t("dam")}</a></td>
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=HORSE_IMPORTED_TYPE`}>{t("importType")}</a></td>
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=COUNTRY_OF_ORIGIN`}>{t("countryOfOrigin")}</a></td>
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=HORSE_AGE`}>{t("age")}</a></td>
                        <td><a href={`/${lang.langCode}/local/info/horse-former-name?frmsorttype=FOALING_DATE`}>{t("foalingDate")}</a></td>
                      </tr>	
                    </thead>
                    <tbody>
                      {
                        // /en-us/local/information/horse?horseid=HK_2016_A369
                        data?.map((item: any, i: number) => (
                          <tr key={i} >
                            {lang?.langCode == "en-us" ? 
                              <>
                                <td className='td-nowrap'><span><a href={`/${lang?.langCode}/local/information/horse?horseid=${item?.id}`}>{item.name_en}</a></span></td>
                              </> :
                              <>
                                <td className='td-nowrap'><span>{item.name_en}</span></td>
                                <td className='td-nowrap'><span><a href={`/${lang?.langCode}/local/information/horse?horseid=${item?.id}`}>{item.name_ch} ({item.code})</a></span></td>
                              </>
                            }
                            <td className='td-nowrap'>
                              {
                                item.formerName == "" ? <center>----</center> : <span>{item.formerName}</span>
                              }
                            </td>
                            <td className='td-nowrap'><span>{item.sire}</span></td>
                            <td className='td-nowrap'><span>{item.dam}</span></td>
                            <td className='td-nowrap'>
                              <div className={lang?.langCode == "en-us" ? "f_tac" : ""}><span>{lang?.langCode == "en-us" ? item.importTypeNm?.code : item.importTypeNm?.chinese}</span></div></td>
                            <td className='td-nowrap'>
                              <div className={lang?.langCode == "en-us" ? "f_tac" : ""}><span>{lang?.langCode == "en-us" ? item.cntyOfOrg?.code : item.cntyOfOrg?.chinese}</span></div></td>
                            <td><center><span>{item.age}</span></center></td>
                            <td><center><span>{handleDate(item.foalingDate, dateFormat.display.date)}</span></center></td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
              </div>
            )
        }
      </div>
      <Footer />
    </>
  );
};
export default HorseFormerName;